import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./store/store";

// Route guards
import PrivateRoute from "./routes/privateRoute";
import PublicRoute from "./routes/publicRoute";

// Pages
import Login from "./pages/login";
import Register from "./pages/register";
import Dashboard from "./pages/dashboard";
import NotFound from "./pages/notfound";
import HighPriority from "./pages/HighPriority";
import Completed from "./pages/Completed";
import Today from "./pages/Today";
// Layout
import MainLayout from "./layout/MainLayout";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route element={<PublicRoute />}>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
          </Route>

          {/* Protected Routes */}
          <Route element={<PrivateRoute />}>
            <Route element={<MainLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="/high-priority" element={<HighPriority />} />
              <Route path="/completed" element={<Completed />} />
              <Route path="/today" element={<Today />} />
            </Route>
          </Route>

          {/* Redirect root to dashboard or login based on auth status */}
          <Route path="/dashboard" element={<Navigate to="/" replace />} />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
